// The ingest contract (instrumentation-and-ingest §6; contracts.md Slice-1 row).
//
// One versioned schema for events and one for feedback, one public ingest endpoint,
// tenant-scoped by a per-app public WRITE key (write-only, never grants read). The
// endpoint is hostile-by-default: the wire schemas are STRICT and deliberately carry NO
// tenant identifiers - `accountId`/`appId` are resolved server-side from the write key,
// so a client cannot address another tenant (instrumentation-and-ingest §8). Free text is
// DATA behind the injection wall.
import { z } from "zod";
import { JsonObject } from "../model/common.js";
import { EventName } from "../model/event.js";
import { FeedbackKind } from "../model/enums.js";
/**
 * The event wire shape the SDK sends. STRICT: an unknown key (including `accountId` or
 * `appId`) is rejected, so a client cannot smuggle a tenant identifier. The server fills
 * the tenant scope from the resolved write key.
 */
export const IngestEvent = z.strictObject({
    name: EventName,
    props: JsonObject,
    anonUser: z.string().min(1).nullable(),
    session: z.string().min(1).nullable(),
    route: z.string().min(1).nullable(),
    occurredAt: z.iso.datetime(),
});
/**
 * The feedback wire shape the widget sends. STRICT for the same reason as {@link IngestEvent};
 * `source` is assigned server-side (the ingest channel), not trusted from the client.
 */
export const IngestFeedback = z.strictObject({
    kind: FeedbackKind,
    body: z.string().min(1).nullable(),
    rating: z.int().nullable(),
    anonUser: z.string().min(1).nullable(),
});
//# sourceMappingURL=ingest.js.map